import { useTranslate } from '@educaplay/core';
import classes from './PillMessage.module.scss';
import { AnimatePresence, motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { SCREENS } from '@educaplay/store/constants';

function PillMessage(props) {

    const { open } = props;
    const t = useTranslate();
    const view = useSelector(state => state.game.view);

    return (
        <AnimatePresence>
            {(open && view === SCREENS.GAME) && (<motion.div className={classes.msgcontainer}
                initial={{ y: "-200%" }}
                animate={{ y: 0}}
                exit={{ y: "-200%" }}
                transition={{ duration: 0.3,  type: "spring", stiffness: 300 }}
            >
                <div className={classes.msgpill}>
                    {t('specific.victorymsg')}
                </div>
            </motion.div>)}
        </AnimatePresence>
    )
}

export default PillMessage;



